<ng-template #statementMenuModalForm let-modal>

  <app-modal-comp-header
    title="Statement"
    (cancelButtonOnClick)="cancelForm()"
  ></app-modal-comp-header>

  <div class="modal-body">
    <p class="text-muted mb-3">
      <span class="fw-medium text-body">{{companyName}}</span>
      @if (periodText != "") {
        <br />{{periodText}}
      }
    </p>

    @if (isReseller) {
      <div class="statement-scope-section mb-3">
        <h6 class="statement-scope-title">
          <i class="ri-building-line me-1 align-middle"></i>This company only
        </h6>
        <ng-container
          [ngTemplateOutlet]="scopeButtons"
          [ngTemplateOutletContext]="{ scope: scopeCompanyOnly }"
        ></ng-container>
      </div>

      <div class="statement-scope-section">
        <h6 class="statement-scope-title">
          <i class="ri-organization-chart me-1 align-middle"></i>This company and all sub-companies
        </h6>
        <ng-container
          [ngTemplateOutlet]="scopeButtons"
          [ngTemplateOutletContext]="{ scope: scopeHierarchy }"
        ></ng-container>
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="scopeButtons"
                    [ngTemplateOutletContext]="{ scope: scopeCompanyOnly }"></ng-container>
    }
  </div>

  <div class="modal-footer justify-content-between">
    <div class="form-check form-switch form-switch-md">
      <label class="form-check-label" for="statementMenuKeepOpen-field">Keep form open</label>
      <input
        [checked]="keepMenuOpen"
        class="form-check-input"
        [disabled]="isBusy"
        id="statementMenuKeepOpen-field"
        role="switch"
        type="checkbox"
        (change)="keepMenuOpenOnChange($any($event.target).checked)"
      >
    </div>
    <button type="button" class="btn btn-light" [disabled]="isBusy" (click)="cancelForm()">Cancel</button>
  </div>
</ng-template>

<ng-template #scopeButtons let-scope="scope">
  <div class="list-group statement-menu">
    <button
      class="list-group-item list-group-item-action d-flex align-items-center"
      [disabled]="!canUseScope(scope) || isBusy"
      type="button"
      (click)="viewOnClick(scope)"
    >
      @if (isGeneratingScope(scope)) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      } @else {
        <i class="ri-file-download-line me-2 align-middle"></i>
      }
      <span>{{ isGeneratingScope(scope) ? 'Generating Statement...' : 'View Statement' }}</span>
      @if (!canViewScope(scope) && !isGeneratingScope(scope)) {
        <small class="text-muted ms-auto statement-not-generated">Generates on first view</small>
      }
    </button>

    @if (canDownloadScope(scope)) {
      <button
        class="list-group-item list-group-item-action d-flex align-items-center"
        [disabled]="isBusy"
        type="button"
        (click)="downloadPdfOnClick(scope)"
      >
        <i class="ri-file-pdf-line me-2 align-middle"></i>
        <span>Download PDF</span>
      </button>
    }

    @if (canDownloadScope(scope)) {
      <button
        class="list-group-item list-group-item-action d-flex align-items-center"
        [disabled]="isBusy"
        type="button"
        (click)="downloadCsvOnClick(scope)"
      >
        <i class="ri-file-excel-2-line me-2 align-middle"></i>
        <span>Download CSV</span>
      </button>
    }

    @if (hasVersionHistory(scope)) {
      <div class="list-group-item statement-version-list">
        <div class="d-flex align-items-center mb-2">
          <i class="ri-history-line me-2 align-middle"></i>
          <span class="fw-medium">Previous versions</span>
        </div>
        @for (statement of versionsForScope(scope); track statement.idEnc) {
          <button
            class="btn btn-sm w-100 text-start d-flex align-items-center statement-version-item"
            [class.active]="isSelectedVersion(scope, statement)"
            [class.text-muted]="!statement.isLatest"
            [disabled]="isBusy"
            type="button"
            (click)="versionOnClick(scope, statement)"
          >
            <span>{{ versionLabel(statement) }}</span>
            <small class="ms-auto statement-version-meta">
              {{ statement.generatedDate | date: 'dd/MM/yyyy HH:mm':'UTC' }}
              @if (statement.generatedByUserName != "") {
                &nbsp;&middot; {{ statement.generatedByUserName }}
              }
            </small>
          </button>
        }
      </div>
    }

    @if (canRegenerateScope(scope)) {
      <button
        class="list-group-item list-group-item-action d-flex align-items-center"
        [disabled]="isBusy"
        type="button"
        (click)="regenerateOnClick(scope)"
      >
        <i class="ri-refresh-line me-2 align-middle"></i>
        <span>Regenerate</span>
      </button>
    }
  </div>
</ng-template>
